<!-- Loader -->
<div *ngIf="loading" id="preloader">
  <div class="sk-three-bounce">
    <div class="sk-child sk-bounce1"></div>
    <div class="sk-child sk-bounce2"></div>
    <div class="sk-child sk-bounce3"></div>
  </div>
</div>


<div id="main-wrapper">
  <router-outlet></router-outlet>
</div>


<!-- NOTIFICATION -->
<ng-snotify></ng-snotify>

<div class="container">
  <div class="row text-center">
    <div class="col-12 py-3">
        Sytrader version 6.9.7
    </div>
  </div>
</div>
